import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import black from "../../images/News/Black_friday.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import "../../styles/News.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import sanvalentino from "../../images/News/Promozioni San Valentino.jpg"
import immagine from "../../images/News/PromoPrimavera2025.png"



function PromoPrimaveraNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"Marzo 2025"}</p>
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <a style={{alignSelf: "end"}} href={immagine} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={immagine} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default PromoPrimaveraNews